import { Reveal, Eyebrow, SectionTitle } from "./Reveal";
import { IMAGES } from "./data";

const CHAPTERS = [
  {
    num: "01",
    title: "Beyond Equipment",
    text: "At Lift Edge Hercules Fitness Store, we believe that quality fitness equipment is only the beginning. What truly matters is the right guidance, dependable products, and service you can count on whenever you need it.",
  },
  {
    num: "02",
    title: "Exclusive & Regional",
    text: "We are the exclusive showroom of Hercules Fitness equipment and accessories — the distributor for North Bengal and Sikkim, delivering across Bihar, West Bengal, Nepal and Bhutan.",
  },
  {
    num: "03",
    title: "For Every Space",
    text: "From professional gym setups to home fitness requirements, we offer a wide range of reliable fitness equipment and accessories designed to meet different training needs and budgets.",
  },
  {
    num: "04",
    title: "Our Goal",
    text: "To provide quality products, honest guidance and dependable after-sales service while building long-term relationships with our customers.",
  },
];

export default function About() {
  return (
    <section id="about" className="relative bg-ink py-24 lg:py-32" data-testid="about-section">
      <div className="mx-auto grid max-w-7xl gap-14 px-5 lg:grid-cols-2 lg:gap-20 lg:px-8">
        <div className="lg:sticky lg:top-28 lg:self-start">
          <Reveal>
            <Eyebrow>About Lift Edge</Eyebrow>
            <SectionTitle>
              Your Trusted <span className="text-edge">Fitness Equipment</span> Partner
            </SectionTitle>
          </Reveal>
          <Reveal delay={0.15} className="relative mt-10">
            <div className="clip-corner relative overflow-hidden border border-line">
              <img
                src={IMAGES.showroom}
                alt="Premium fitness equipment on display at the Lift Edge showroom"
                className="aspect-[4/3] w-full object-cover transition-transform duration-700 hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/70 to-transparent" />
              <p className="absolute bottom-4 left-4 font-mono text-[10px] uppercase tracking-[0.25em] text-white/80">
                Siliguri Showroom · Sevoke Road
              </p>
            </div>
          </Reveal>
        </div>

        <div className="flex flex-col justify-center">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.num} delay={i * 0.08}>
              <div
                className="group border-b border-line py-8 transition-colors duration-300 first:pt-0 hover:border-edge/50"
                data-testid={`about-manifesto-chapter-${i + 1}`}
              >
                <div className="flex items-baseline gap-5">
                  <span className="font-display text-3xl font-black text-outline-silver transition-colors">
                    {c.num}
                  </span>
                  <div>
                    <h3 className="font-display text-2xl font-bold uppercase tracking-wide text-white">
                      {c.title}
                    </h3>
                    <p className="mt-2 leading-relaxed text-ash">{c.text}</p>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
